import type { PreferredCourtsValues } from 'utils/shared/playerFinder';
import { PreferredVenuesField } from 'components/PlayerFinder';
import ProfileFormModal from './ProfileFormModal';
import type { ProfileEditorModalProps } from './types';
import { useModalDraft } from './useModalDraft';

interface Props extends ProfileEditorModalProps {
  defaultValues: PreferredCourtsValues | null;
  onSave: (values: PreferredCourtsValues) => Promise<boolean>;
}

export default function PreferredCourtsFormModal({
  isOpen,
  onClose,
  defaultValues,
  onSave,
  isSaving,
  error,
}: Props) {
  const { values, setValues, handleSave } = useModalDraft(isOpen, defaultValues, onSave, onClose);

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Preferred courts"
      description="Add the courts you play at so nearby players can find you."
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    >
      {values && (
        <PreferredVenuesField
          venues={values.venues}
          onChange={(venues) => setValues({ ...values, venues })}
        />
      )}
    </ProfileFormModal>
  );
}
